<template>
    <div>
        <!-- <topSearch></topSearch> -->
        <!-- <breadcrumb></breadcrumb> -->

        <div class="top-title-content">
            <span class="title">수업관리</span>
            <span class="txt">이용권 결제, 수정, 삭제, 환불신청을 할 수 있고, 만료회원 정보를 확인할 수 있습니다.</span>
        </div>

        <div class="top-info-lesson">
            <p class="com-sub-title">히스토리 내역</p>
            <p class="info-txt">
                <span class="txt">{{ name }} 회원</span>
                <span class="txt">{{ covertTicket(type) }}{{ title }}</span>
                <!-- <span class="txt">{{convertTime(time)}}({{convertMinutes(totaltime)}})</span> -->
            </p>
        </div>

        <div class="com-search-content">
            <div class="line">
                <div class="com-calendar-wrap">
                    <single-calendar :start-date="startDate" @update="startDateUpdate"></single-calendar>
                    <div class="com-dash"><span class="dash">~</span></div>
                    <single-calendar :end-date="endDate" @update="endDateUpdate"></single-calendar>
                </div>
                <select-form
                    :select-data="['선택', ...periodTypeList]"
                    :select-value="['', ...periodTypeValueList]"
                    :selected-value="searchPeriod"
                    @update:set="(val) => (searchPeriod = val)"
                ></select-form>
                <select-form
                    :select-data="['전체', '등록', '기본정보', '결제', '유효기간', '환불', '직원변경']"
                ></select-form>
                <div class="com-search-input">
                    <input placeholder="내용 입력" type="text" />
                    <button class="search-btn" @click="onEventSearch">검색</button>
                </div>
            </div>
        </div>

        <div class="com-table-content">
            <table class="com-table">
                <colgroup>
                    <col style="width: 300px" />
                    <col style="width: 240px" />
                    <col style="width: 710px" />
                    <col style="width: 180px" />
                </colgroup>
                <thead>
                    <tr>
                        <th>수정시간</th>
                        <th>수정내역</th>
                        <th>내용</th>
                        <th>입력자</th>
                    </tr>
                </thead>
                <tbody v-if="historyList.length > 0">
                    <!-- <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>환불</td>
                    <td class="left">2020-01-13 환불 300,000원이 완료되었습니다.</td>
                    <td>김윤경</td>
                </tr>
                <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>환불</td>
                    <td class="left">2020-01-10 환불 300,000원을 신청하였습니다.</td>
                    <td>김윤경</td>
                </tr>
                <tr>
                    <td>2020-01-22 10:54:22</td>
                    <td>프로그램명</td>
                    <td class="left">결제정보 – 1의 결제일자를 <span class="blue">2019-08-20</span>에서 <span class="blue">2019-08-21</span>으로(로) 수정하였습니다.</td>
                    <td>김윤경</td>
                </tr> -->
                    <tr v-for="(h, index) in historyList" :key="index">
                        <td>{{ h.ev_cre_dt | timestampFilter2 }}</td>
                        <td>{{ convertCode(h.ev_event_type_cd) }}</td>
                        <td class="left">{{ h.ev_event_content }}</td>
                        <td>{{ h.cs_staff_name }}</td>
                    </tr>
                </tbody>
                <tbody v-else>
                    <tr>
                        <td colspan="100">등록된 내용이 없습니다.</td>
                    </tr>
                </tbody>
            </table>
            <div class="sort-bottom-area">
                <button class="com-btn excel" @click="excelDownload">엑셀 다운로드</button>
                <select-form
                    :select-data="[...sortTypeList]"
                    :select-value="[...sortTypeValueList]"
                    class="float-right"
                    @update:set="changeLimit"
                ></select-form>
            </div>
        </div>
        <b-pagination
            v-model="pagingInfo.page"
            :per-page="pagingInfo.limit"
            :total-rows="pagingInfo.totalItems"
            align="center"
            aria-controls="my-table"
            first-class="first"
            last-class="last"
            next-class="next"
            prev-class="prev"
            @change="handlerPagenation($event)"
        ></b-pagination>
    </div>
</template>

<script>
import api from '@/assets/js/api';
import moment from 'moment';
import XLSX from 'xlsx';
import { pagingInfo } from '@/assets/js/common';
export default {
    name: 'CourseCareHistory',
    props: {},
    computed: {
        cId() {
            const { getters } = this.$store;
            return getters['auth/cId'];
        },
    },
    watch: {
        period: function (newValue) {
            this.searchPeriod = newValue;

            if (newValue === 'today') {
                // 오늘
                this.startDate = moment().format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === 'yesterday') {
                // 어제
                this.startDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'days').format('YYYY-MM-DD');
            } else if (newValue === 'thisMonth') {
                // 이번 달
                this.startDate = moment().startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().endOf('month').format('YYYY-MM-DD');
            } else if (newValue === 'prevMonth') {
                // 지난 달
                this.startDate = moment().subtract(1, 'months').startOf('month').format('YYYY-MM-DD');
                this.endDate = moment().subtract(1, 'months').endOf('month').format('YYYY-MM-DD');
            } else if (newValue === '3M') {
                // 3개월
                this.startDate = moment().subtract(3, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '6M') {
                // 6개월
                this.startDate = moment().subtract(6, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '12M') {
                // 12개월
                this.startDate = moment().subtract(12, 'months').format('YYYY-MM-DD');
                this.endDate = moment().format('YYYY-MM-DD');
            } else if (newValue === '') {
                this.initStartDate();
                this.initEndDate();
            }
            this.onSearchList();
        },
        startDate: function (newValue) {
            this.startDate = newValue;
        },
        endDate: function (newValue) {
            this.endDate = newValue;
        },
    },
    data() {
        return {
            periodTypeList: [...this.$periodTypeList],
            periodTypeValueList: [...this.$periodTypeValueList],
            sortTypeList: [...this.$sortType],
            sortTypeValueList: [...this.$sortTypeValue],

            name: this.$route.params.name,
            title: this.$route.params.title,
            type: this.$route.params.type,

            centerId: '',
            historyList: [],
            pagingInfo: { ...pagingInfo },
            period: '',
            startDate: '',
            endDate: '',
            searchStr: '',
            searchPeriod: '', // 검색기간 설정

            centerCustomerId: this.$route.params.custId,
            centerContractId: this.$route.params.contractId,
        };
    },
    mounted() {
        this.centerId = this.cId; // 센터 Id
        this.init();
    },
    methods: {
        async init() {
            this.pagingInfo.page = 1;
            this.pagingInfo.limit = 10;
            this.initStartDate(); // 검색 시작일 초기화
            this.initEndDate(); // 검색 종료일 초기화
            this.onSearchList();
        },
        async onSearchList() {
            try {
                const { data } = await this.getSearchList();
                this.historyList = data.items;
            } catch (error) {
                console.log(error);
            }
        },
        getSearchList() {
            // 스웨거검색: 센터 회원계약 이벤트이력 조회
            return api.get(
                `/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}/contract/event/history/paging`,
                {
                    params: {
                        centerContractId: this.centerContractId,
                        ...this.pagingInfo,
                    },
                }
            );
        },
        // 한 페이지에 표시되는 줄 수 변경
        changeLimit(val) {
            this.pagingInfo.limit = val;
            this.onSearchList();
        },

        // 페이징 이벤트
        handlerPagenation(event) {
            this.pagingInfo.page = event;
            this.onSearchList();
        },

        // 검색 시작일 초기화
        initStartDate() {
            const startDate = moment().subtract(1, 'years').format('YYYY-MM-DD');
            this.startDate = startDate;
        },

        // 검색 종료일 초기화
        initEndDate() {
            const endDate = moment().format('YYYY-MM-DD');
            this.endDate = endDate;
        },

        // 검색 시작일 변경 event
        startDateUpdate(val) {
            this.startDate = val;
        },

        // 검색 종료일 변경 event
        endDateUpdate(val) {
            this.endDate = val;
        },
        // 페이징 Param 설정
        setPageParams(data) {
            this.pagingInfo.totalPages = data.meta.totalPages;
            this.pagingInfo.page = data.meta.currentPage;
            this.pagingInfo.totalItems = data.meta.totalItems;
            this.pagingInfo.itemCount = data.meta.itemCount;
        },
        // 키워드 검색 이벤트
        onEventSearch(e) {
            if (this.searchStr.length > 0 && this.searchStr.length < 2) {
                return;
            }
            this.onSearchList();
        },
        //수업요일 변환
        convertWeek(weeks) {
            if (weeks === null || weeks === '' || weeks === undefined) {
                return weeks;
            }
            let week1 = weeks.split(':');
            console.log(week1);
            let week = ['월', '화', '수', '목', '금', '토', '일'];
            let str = '';
            for (let i = 0; i < week1.length; i++) {
                if (week1[i] == 'O') str += `${week[i]}/`;
            }
            return str.slice(0, -1);
        },
        //시간 변환
        convertMinutes(minutes) {
            if (minutes == 30) {
                return '30분';
            } else if (minutes == 60) {
                return '1시간';
            } else if (minutes == 90) {
                return '1시간30분';
            } else if (minutes == 120) {
                return '2시간';
            }
        },
        convertTime(time) {
            if (time === null || time === '' || time === undefined) {
                //예외처리
                return time; //예외처리
            }
            return time.substring(0, 5);
        },
        covertTicket(ticket) {
            if (ticket == 'P') {
                return '[개인]';
            } else if (ticket == 'D') {
                return '[듀엣]';
            } else if (ticket == 'O') {
                return '[OT]';
            } else if (ticket == 'G') {
                return '[그룹]';
            }
        },
        convertCode(code) {
            // 코드값 맞춰야됨.
            if (code === 'CR') {
                return '등록';
            } else if (code === 'BE') {
                return '기본정보';
            } else if (code === 'PY') {
                return '결제';
            } else if (code === 'PE') {
                return '유효기간';
            } else if (code === 'RF') {
                return '환불';
            } else if (code === 'ST') {
                return '직원변경';
            } else if (code === 'TR') {
                return '양도';
            } else if (code === 'HD') {
                return '홀딩';
            } else if (code === 'EP') {
                return '기간연장';
            }
        },
        async excelDownload() {
            const { data } = await this.getCareHistoryExcel(); // 엑셀용 요청값

            let excelDownloadArray = [];
            data.items.forEach((h) => {
                const temp = {};
                temp['수정시간'] = moment(h.ev_cre_dt).format('YYYY-MM-DD HH:mm:ss');
                temp['수정내역'] = this.convertCode(h.ev_event_type_cd);
                temp['내용'] = h.ev_event_content;
                temp['입력자'] = h.cs_staff_name;

                excelDownloadArray.push(temp);
            });

            /*[Key:value, ...]*/
            const dataWS = XLSX.utils.json_to_sheet(excelDownloadArray);

            // cell width 설정
            const wscols = [
                { wch: 12 },
                { wch: 24 },
                { wch: 50 },
                { wch: 30 },
                { wch: 12 },
                { wch: 35 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
                { wch: 12 },
            ];
            dataWS['!cols'] = wscols;

            // cell height 설정
            const wsrows = [{ hpx: 30 }];
            dataWS['!rows'] = wsrows;

            const wb = XLSX.utils.book_new();

            XLSX.utils.book_append_sheet(wb, dataWS, '수업 히스토리 내역');
            XLSX.writeFile(wb, '수업 히스토리 내역.xlsx');
        },
        getCareHistoryExcel() {
            return api.get(
                `/admin/api/center/${this.centerId}/customer/${this.centerCustomerId}/contract/event/history/paging`,
                {
                    params: {
                        centerContractId: this.centerContractId,
                        ...this.pagingInfo,
                        limit: 10000,
                    },
                }
            );
        },
    },
};
</script>
<style lang="scss"></style>
